import { render, staticRenderFns } from "./ViewOrdersToDispatch.vue?vue&type=template&id=7f306905&scoped=true&"
import script from "./ViewOrdersToDispatch.vue?vue&type=script&lang=js&"
export * from "./ViewOrdersToDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f306905",
  null
  
)

export default component.exports